import { createAction } from 'redux-act'

export const setLoading = createAction('Set Loading')